export default {
  // baseURL: 'http://113.254.9.134:1337//',
  // withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('at')}`
  }
}
